import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import Dashboard from '../views/Dashboard.vue';
import Tournaments from '../views/Tournaments.vue';
import TournamentDetail from '../views/TournamentDetail.vue';
import Leaderboard from '../views/Leaderboard.vue';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'tournaments', component: Tournaments },
    { path: '/tournaments/:id', name: 'tournament', component: TournamentDetail },
    { path: '/login', name: 'login', component: Login },
    { path: '/register', name: 'register', component: Register },
    { path: '/dashboard', name: 'dashboard', component: Dashboard, meta: { requiresAuth: true } },
    { path: '/leaderboard', name: 'leaderboard', component: Leaderboard }, // 👈 NUEVA
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requiresAuth)) {
    if (!store.getters.isAuth) return next({ name: 'login', query: { redirect: to.fullPath } });
  }
  next();
});

export default router;
